import { PageShell, ContactSection } from "@/components/sections";

const Contact = () => (
  <PageShell testId="contact-page">
    <ContactSection />
  </PageShell>
);

export default Contact;
